import { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Form, message, Popconfirm } from "antd";
import { PlusOutlined, DeleteOutlined, LinkOutlined } from "@ant-design/icons";
import agreementService from "../services/agreementService";
import { toast } from 'react-toastify';

const { TextArea } = Input;

const Agreements = () => {
  const [agreements, setAgreements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const fetchAgreements = async () => {
    setLoading(true);
    try {
      const data = await agreementService.getAllAgreements();
      setAgreements(data);
    } catch (error) {
      message.error("Sözleşmeler alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    form.resetFields();
    setIsModalOpen(true);
  };

  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      
      const response = await agreementService.addAgreement({
        name: values.name,
        description: values.description,
        url: values.url
      });

      if (response?.Status) {
        toast.success("Sözleşme başarıyla eklendi.");
        setIsModalOpen(false);
        form.resetFields();
        fetchAgreements();
      } else {
        toast.error(response?.Message || "Sözleşme eklenemedi.");
      }
    } catch (error) {
      if (error.errorFields) {
        message.error("Lütfen tüm alanları doldurun.");
      } else {
        toast.error("Sözleşme eklenirken hata oluştu.");
      }
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await agreementService.deleteAgreement(id);
      if (response?.Status) {
        toast.success("Sözleşme başarıyla silindi.");
        fetchAgreements();
      } else {
        toast.error(response?.Message || "Sözleşme silinemedi.");
      }
    } catch (error) {
      toast.error("Sözleşme silinirken hata oluştu.");
    }
  };

  const columns = [
    {
      title: "Sözleşme Adı",
      dataIndex: "name",
      key: "name",
      width: '20%'
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      width: '45%',
      ellipsis: true,
      render: (text) => (
        <span title={text}>
          {text?.length > 150 ? `${text.substring(0, 150)}...` : text}
        </span>
      )
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: '15%',
      ellipsis: true,
      render: (url) => url ? (
        <a href={url} target="_blank" rel="noopener noreferrer" title={url}>
          <LinkOutlined /> Link
        </a>
      ) : '-'
    },
    {
      title: "Oluşturma Tarihi",
      dataIndex: "createTime",
      key: "createTime",
      width: '10%',
      render: (date) => date ? new Date(date).toLocaleDateString('tr-TR') : '-'
    },
    {
      title: "İşlem",
      key: "action",
      width: '10%',
      render: (_, record) => (
        <Popconfirm
          title="Sözleşmeyi silmek istediğinize emin misiniz?"
          onConfirm={() => handleDelete(record.id)}
          okText="Evet"
          cancelText="Hayır"
        >
          <Button 
            type="primary" 
            danger 
            icon={<DeleteOutlined />}
            size="small"
          >
            Sil
          </Button>
        </Popconfirm>
      ),
    },
  ];

  useEffect(() => {
    fetchAgreements();
  }, []);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Sözleşmeler</h2>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAdd}
        >
          Yeni Sözleşme Ekle
        </Button>
      </div>

      <Table
        columns={columns}
        dataSource={agreements}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize: 10,
          showTotal: (total) => `Toplam ${total} sözleşme`
        }}
      />

      <Modal
        title="Sözleşme Ekle"
        open={isModalOpen}
        onOk={handleModalOk}
        onCancel={() => {
          setIsModalOpen(false);
          form.resetFields();
        }}
        width={700}
        okText="Kaydet"
        cancelText="İptal"
      >
        <Form
          form={form}
          layout="vertical"
          name="agreementForm"
        >
          <Form.Item
            name="name"
            label="Sözleşme Adı"
            rules={[
              {
                required: true,
                message: "Lütfen sözleşme adını girin!",
              },
            ]}
          >
            <Input placeholder="Sözleşme adını girin" />
          </Form.Item>

          <Form.Item
            name="url"
            label="Sözleşme URL"
            rules={[
              {
                required: false,
              },
              {
                type: 'url',
                message: 'Lütfen geçerli bir URL girin!',
              },
            ]}
          >
            <Input 
              placeholder="https://example.com/sozlesme.pdf" 
              prefix={<LinkOutlined />}
            />
          </Form.Item>

          <Form.Item
            name="description"
            label="Açıklama"
            rules={[
              {
                required: true,
                message: "Lütfen sözleşme açıklamasını girin!",
              },
            ]}
          >
            <TextArea
              rows={10}
              placeholder="Sözleşme açıklamasını girin"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Agreements;